import { defineMessages } from '@formatjs/intl';

export const tiktokDisclosureMessages = defineMessages({
  disclosureDescription: {
    id: 'socialExport.tiktok.disclosure.description',
    defaultMessage:
      'Activa esta opción si el vídeo promociona bienes o servicios a cambio de valor. El contenido puede promocionar tu marca, a un tercero o a ambos.',
  },
  yourBrandLabel: {
    id: 'socialExport.tiktok.disclosure.yourBrand.label',
    defaultMessage: 'Tu marca',
  },
  yourBrandDescription: {
    id: 'socialExport.tiktok.disclosure.yourBrand.description',
    defaultMessage:
      "Promocionas tu propia marca o negocio. El vídeo se clasificará como 'Brand Organic'.",
  },
  brandedContentLabel: {
    id: 'socialExport.tiktok.disclosure.brandedContent.label',
    defaultMessage: 'Contenido de otra marca',
  },
  brandedContentDescription: {
    id: 'socialExport.tiktok.disclosure.brandedContent.description',
    defaultMessage:
      "Promocionas a otra marca o a un tercero. El vídeo se clasificará como 'Contenido de marca'.",
  },
  discloseVideoContent: {
    id: 'socialExport.tiktok.disclosure.toggle',
    defaultMessage: 'Declarar contenido promocional',
  },
  labelPromotionalContent: {
    id: 'socialExport.tiktok.disclosure.labelPromotionalContent',
    defaultMessage: "La publicación se etiquetará como 'Contenido promocional'.",
  },
  /** Full alert when only "Your brand" is selected (with "cannot be changed" line). */
  promotionalLabel: {
    id: 'socialExport.tiktok.disclosure.promotionalLabel',
    defaultMessage:
      "Tu vídeo se etiquetará como 'Contenido promocional'. No podrá cambiarse una vez publicado.",
  },
  labelPaidPartnership: {
    id: 'socialExport.tiktok.disclosure.labelPaidPartnership',
    defaultMessage: "La publicación se etiquetará como 'Colaboración pagada'.",
  },
  /** Full alert when "Branded content" (or both) is selected (with "cannot be changed" line). */
  labelPaidPartnershipAlert: {
    id: 'socialExport.tiktok.disclosure.labelPaidPartnershipAlert',
    defaultMessage:
      "Tu vídeo se etiquetará como 'Colaboración pagada'. No podrá cambiarse una vez publicado.",
  },
  selectAtLeastOneHint: {
    id: 'socialExport.tiktok.disclosure.selectAtLeastOneHint',
    defaultMessage: 'Selecciona al menos una opción: tu marca, un tercero o ambos.',
  },
  brandedContentVisibility: {
    id: 'socialExport.tiktok.disclosure.brandedContentVisibilityCannotBePrivate',
    defaultMessage: 'La privacidad de contenido promocional de otra marca no puede ser "Solo Yo".',
  },
  /** Shown when hovering over the disabled "only me" option in privacy select (branded content on). */
  brandedContentVisibilityTooltip: {
    id: 'socialExport.tiktok.disclosure.brandedContentVisibilityTooltip',
    defaultMessage: 'La visibilidad del contenido de marca no puede ser privada.',
  },
  brandedContentAndMusicAgree: {
    id: 'socialExport.tiktok.disclosure.brandedContentAndMusicAgree',
    defaultMessage: 'Al publicar, aceptas la {brandedContentLink} y la {musicLink} de TikTok.',
  },
  brandedContentPolicyLink: {
    id: 'socialExport.tiktok.disclosure.brandedContentPolicyLink',
    defaultMessage: 'Política de contenido de marca',
  },
  musicUsageConfirmationLink: {
    id: 'socialExport.tiktok.disclosure.musicUsageConfirmationLink',
    defaultMessage: 'Política de uso de música de TikTok',
  },
  musicUsageAgree: {
    id: 'socialExport.tiktok.disclosure.musicUsageAgree',
    defaultMessage: 'Al publicar, aceptas la {link}.',
  },
});
